import type { EventSourceStop } from '@festina/life-general-types/life'

export const isInStop = (stop: EventSourceStop['stop']) =>
  !!(
    stop?.applyStop ||
    stop?.communicationStop ||
    stop?.fullStop ||
    stop?.errorApplyStop
  )

// Contact person: @mof / @fb
// Calculations cannot be done during any of these stops
export const isInCalculationStop = (stop: EventSourceStop['stop']) =>
  !!(stop?.applyStop || stop?.fullStop || stop?.errorApplyStop)
